import { AppForm } from '../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { bothRequired } from '../../../../../../common/forms/custom.validators';

export class UnrelatedDeviceForm extends AppForm {
  constructor() {
    super({
      deviceType: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      roadwayWidth: new FormControl('', { nonNullable: true, validators: [Validators.maxLength(255)] }),
      roadwayLength: new FormControl('', { nonNullable: true, validators: [Validators.maxLength(255)] }),
      roadwayArea: new FormControl({ value: '', disabled: true }, {
        nonNullable: true,
        validators: [Validators.maxLength(255)]
      }),
      sidewalkWidth: new FormControl('', { nonNullable: true, validators: [Validators.maxLength(255)] }),
      sidewalkLength: new FormControl('', { nonNullable: true, validators: [Validators.maxLength(255)] }),
      sidewalkArea: new FormControl({ value: '', disabled: true }, {
        nonNullable: true,
        validators: [Validators.maxLength(255)]
      }),
      remainingElementsWidth: new FormControl('', { nonNullable: true, validators: [Validators.maxLength(255)] }),
      remainingElementsLength: new FormControl('', { nonNullable: true, validators: [Validators.maxLength(255)] }),
      remainingElementsArea: new FormControl({ value: '', disabled: true }, {
        nonNullable: true,
        validators: [Validators.maxLength(255)]
      }),
      bridgeStructureWidth: new FormControl('', { validators: [Validators.maxLength(255)] }),
      bridgeStructureLength: new FormControl('', { validators: [Validators.maxLength(255)] }),
      bridgeStructureArea: new FormControl({ value: '', disabled: true }, {
        nonNullable: true,
        validators: [Validators.maxLength(255)]
      }),
      placementDate: new FormControl(null, { validators: [Validators.required, Validators.maxLength(255)] })
    }, {
      validators: [
        bothRequired(['roadwayWidth', 'roadwayLength']),
        bothRequired(['sidewalkWidth', 'sidewalkLength']),
        bothRequired(['remainingElementsWidth', 'remainingElementsLength']),
        bothRequired(['bridgeStructureWidth', 'bridgeStructureLength'])
      ]
    });
  }

  public get placementDate(): FormControl {
    return this.get('placementDate') as FormControl;
  }

  public get deviceType(): FormControl {
    return this.get('deviceType') as FormControl;
  }

  public get roadwayWidth(): FormControl {
    return this.get('roadwayWidth') as FormControl;
  }

  public get roadwayLength(): FormControl {
    return this.get('roadwayLength') as FormControl;
  }

  public get roadwayArea(): FormControl {
    return this.get('roadwayArea') as FormControl;
  }

  public calcRoadwayArea(): void {
    const roadwayWidth: number = +this.roadwayWidth.value;
    const roadwayLength: number = +this.roadwayLength.value;
    if (!roadwayLength || !roadwayWidth) {
      this.roadwayArea.setValue('');
    } else {
      this.roadwayArea.setValue(roadwayWidth * roadwayLength);
    }

  }

  public get sidewalkWidth(): FormControl {
    return this.get('sidewalkWidth') as FormControl;
  }

  public get sidewalkLength(): FormControl {
    return this.get('sidewalkLength') as FormControl;
  }

  public get sidewalkArea(): FormControl {
    return this.get('sidewalkArea') as FormControl;
  }

  public calcSidewalkArea(): void {
    const sidewalkWidth: number = +this.sidewalkWidth.value;
    const sidewalkLength: number = +this.sidewalkLength.value;
    if (!sidewalkWidth || !sidewalkLength) {
      this.sidewalkArea.setValue('');
    } else {
      this.sidewalkArea.setValue(sidewalkWidth * sidewalkLength);
    }
  }

  public get remainingElementsWidth(): FormControl {
    return this.get('remainingElementsWidth') as FormControl;
  }

  public get remainingElementsLength(): FormControl {
    return this.get('remainingElementsLength') as FormControl;
  }

  public get remainingElementsArea(): FormControl {
    return this.get('remainingElementsArea') as FormControl;
  }

  public calcRemainingElementsArea(): void {
    const remainingElementsWidth: number = +this.remainingElementsWidth.value;
    const remainingElementsLength: number = +this.remainingElementsLength.value;
    if (!remainingElementsWidth || !remainingElementsLength) {
      this.remainingElementsArea.setValue('');
    } else {
      this.remainingElementsArea.setValue(remainingElementsWidth * remainingElementsLength);
    }
  }

  public get bridgeStructureWidth(): FormControl {
    return this.get('bridgeStructureWidth') as FormControl;
  }

  public get bridgeStructureLength(): FormControl {
    return this.get('bridgeStructureLength') as FormControl;
  }

  public get bridgeStructureArea(): FormControl {
    return this.get('bridgeStructureArea') as FormControl;
  }

  public calcBridgeStructureArea(): void {
    const bridgeStructureWidth: number = +this.bridgeStructureWidth.value;
    const bridgeStructureLength: number = +this.bridgeStructureLength.value;
    if (!bridgeStructureLength || !bridgeStructureWidth) {
      this.bridgeStructureArea.setValue('');
    } else {
      this.bridgeStructureArea.setValue(bridgeStructureWidth * bridgeStructureLength);
    }
  }
}
